const instances = new Set();
const privateProps = new WeakMap();

export {
	instances,
	privateProps,
};